(function(){"use strict";}());

angular.module("app")
    .directive("mapView", ["AppService", "$timeout","$rootScope", function(AppService, $timeout, $rootScope){

        return {
            restrict: "A",
            replace: false,
            templateUrl: "views/map.html",
            controllerAs: "Map",
            controller: function($scope){
                var map = this;
                var trace = angular.trace;

                map.collectedObjectCount = 1;

                $timeout(initialize,0);
               
               // $scope.$watch("currentAdventure",onAdventureChange);
               // $scope.$on("locationComplete",onArtifactCollected);
               // $scope.$on("reset",onReset);
               // $scope.$watch("currentPageIndex",onPageChange);

               if($rootScope.resetMap === true){
                    $rootScope.resetMap = false;
                    onReset();
               }

               function initialize(){

                    map.locations = $scope.currentAdventure.locations;
                    map.title = $scope.currentAdventure.title;
                    map.user = $scope.currentAdventure.user;

                    if(!$scope.mapCache.populated){
                        $scope.mapCache.populated = true;
                        $scope.currentQuestion = null;
                        $scope.currentQuestionIndex = 0;
                        $scope.localLocation = null;
                        $scope.playerLocation = null;
                        $scope.questionList = [];
                        $scope.mapCache.questionList = $scope.questionList = buildQuestionList();
                    }
                    else{
                        map.locations = $scope.currentAdventure.locations;
                        map.user = $scope.currentAdventure.user;
                        map.title = $scope.currentAdventure.title;
                        $scope.currentQuestion = $scope.mapCache.currentQuestion;
                        //$scope.localLocation = $scope.mapCache.localLocation;
                        $scope.playerLocation = $scope.mapCache.playerLocation;
                        $scope.questionList = $scope.mapCache.questionList;
                        cachedStyles = $scope.mapCache.styles;
                    }
                    $scope.mapCache.currentQuestionIndex = $scope.currentQuestionIndex = $scope.locationsComplete;
                    map.setQuestion($scope.currentQuestionIndex);
                    $scope.styles = map.buildDynamicStyles(true);
                    if($scope.hoursRemaining === 0) 
                    {
                        $scope.setCurrentPage($scope.PAGE_LOSE_PRE);
                        var evt = {
                            eventCategory: "GRTT: Game",
                            eventLabel:  "GRTT: game"
                        };
                        gtag("event", "GRTT: end - incomplete", evt);
                    }
                }



                map.openPopup = function(popup){

                    $scope.mapCache.localLocation = $scope.localLocation = popup;
                    var popups = map.locations;
                    for(var i = 0, count = popups.length; i < count; i++){
                        if(popups[i] === popup) popups[i].popup = !popups[i].popup;
                        else popups[i].popup = false;
                    }
                };



                map.clickPoi = function(popup){
                    if(popup == $scope.localLocation){
                        map.goToPage($scope.localLocation);
                        //$rootScope.$emit("audio","Motorbike");
                    } else {
                        $scope.mapCache.localLocation = $scope.localLocation = popup;
                        var popups = map.locations;
                        for(var i = 0, count = popups.length; i < count; i++){
                            if(popups[i] === popup) popups[i].popup = !popups[i].popup;
                            else popups[i].popup = false;
                        }
                        $rootScope.$emit("audio","Button_Select");
                    }
                };

                map.collectedObjects = function(){
                    return map.collectedObjectCount ? map.collectedObjectCount : "0";
                };


                map.objectCount = function(){

                    var objects = 0;
                    map.collectedObjectCount = 0;
                    trace("counting objects",map.locations);
                    if(!map.locations || !$scope.currentAdventure) return objects;
                    for(var i = 0, count = map.locations.length; i < count; i++){
                        if(map.locations[i].artifact) objects++;
                        if(map.locations[i].artifact && map.locations[i].artifact.complete) map.collectedObjectCount ++;
                    }
                    return objects;

                };

                map.isComplete = function(){
                    var objects = map.objectCount();
                    return objects === map.collectedObjectCount;
                };


                map.goToPage = function(location){
                    $scope.mapCache.playerLocation = $scope.playerLocation = location;
                    $scope.styles = map.buildDynamicStyles();
                    $timeout(function(){
                        location.correct = locationIsCorrect(location);
                        if(checkCompletion(location)) return;
                        $scope.drawDownHours(4);
                        $scope.setCurrentLocation(location);
                        $scope.setCurrentPage($scope.PAGE_MAP_POST);
                        if(!location.correct){
                            var evt = {
                                eventCategory: "GRTT: Game",
                                eventLabel:  "GRTT: location"
                            };
                            gtag("event", "GRTT: incorrect location selected", evt);
                        }
                    }, 1200);
                };

                map.setQuestion = function(index){
                    $scope.mapCache.currentQuestionIndex = $scope.currentQuestionIndex = index;
                    $scope.mapCache.currentQuestion = $scope.currentQuestion = $scope.questionList[index];
                };

                map.clearCurrentLocation = function(){
                    $scope.mapCache.localLocation = $scope.localLocation = null;
                    $scope.mapCache.playerLocation = $scope.playerLocation = null;
                    $scope.setCurrentLocation(null);
                };

                var cachedStyles = null;

                map.buildDynamicStyles = function(preventTransition){
                    if(!$scope.playerLocation) return cachedStyles;
                    var topPosition = $scope.playerLocation.position.top - 740;
                    var leftPosition = $scope.playerLocation.position.left - 420;
                    cachedStyles = "div#app-container section#map-page div.map div.poi-bucket div.poi.user-poi { ";
                    cachedStyles += "moz-transform: translate3d("+leftPosition+"px,"+topPosition+"px,0);";
                    cachedStyles += "webkit-transform: translate3d("+leftPosition+"px,"+topPosition+"px,0);";
                    cachedStyles += "transform: translate3d("+leftPosition+"px,"+topPosition+"px,0);";
                    if(preventTransition === true){
                        cachedStyles += "-moz-transition: all 0s; -webkit-transition: all 0s; transition: all 0s;";
                    }
                    cachedStyles += " }";

                    $scope.mapCache.styles = cachedStyles;
                    return cachedStyles;
                };

                function onArtifactCollected(){
                    map.setQuestion($scope.currentQuestionIndex + 1);
                }

                function onReset(){
                    $scope.mapCache.currentQuestion = $scope.currentQuestion = null;
                    $scope.mapCache.currentQuestionIndex = $scope.currentQuestionIndex = 0;
                    $scope.mapCache.localLocation = $scope.localLocation = null;
                    $scope.mapCache.playerLocation = $scope.playerLocation = null;
                    $scope.mapCache.questionList = $scope.questionList = [];
                    $scope.mapCache.populated = false;
                    cachedStyles = null;
                }

                function checkCompletion(location){
                    if($scope.currentQuestionIndex < $scope.questionList.length - 1) return false;
                    if(location.correct === true)
                    {
                        $scope.setCurrentLocation(location);
                        $scope.setCurrentPage($scope.PAGE_COMPLETION_PRE);
                        var evt = {
                            eventCategory: "GRTT: Game",
                            eventLabel:  "GRTT: game"
                        };
                        gtag("event", "GRTT: end - complete", evt);
                    }
                    else if($scope.hoursRemaining >= 4) {
                        $scope.drawDownHours(4);
                        $scope.setCurrentLocation(location);
                        location.complete = true;
                        $scope.setCurrentPage($scope.PAGE_MAP_POST);
                    }
                    else
                    {
                        $scope.setCurrentLocation(location);
                        $scope.setCurrentPage($scope.PAGE_LOSE_PRE);
                    }
                    return true;
                }

                function onAdventureChange(val){
                    if(!val) return;
                    if($scope.mapCache.populated === true) return;
                    /*
                    map.locations = $scope.currentAdventure.locations;
                    map.title = $scope.currentAdventure.title;
                    map.user = $scope.currentAdventure.user;
                    $scope.mapCache.questionList = $scope.questionList = buildQuestionList();
                    map.setQuestion(0);*/
                }

                function locationIsCorrect(location){
                    var correctAnswer = getCorrectAnswer();
                    return correctAnswer.text === location.title;
                }
                function getCorrectAnswer(){
                    var answers = $scope.currentQuestion.answers;
                    for(var i = 0, count = answers.length; i < count; i++){
                        if(answers[i].correct === true) return answers[i];
                    }
                    return null;
                }

                function buildQuestionList(){
                    var questions = $scope.currentAdventure.questions.concat();
                    var locations = questions.splice(0,questions.length-1);

                    locations.sort(function(a,b){
                        //var testString = "strategic trade location westward"; //ce / louisville
                        //var testString = "capital was moved shortly"; //mem / aug
                        //if(a.text.indexOf(testString) !== -1) return -1;
                        //if(b.text.indexOf(testString) !== -1) return 1;

                        //move to end
                        //if(a.text.indexOf("capital was moved here") !== -1) return 1;
                        //if(b.text.indexOf("capital was moved here") !== -1) return -1;

                        return Math.random() > 0.5 ? 1:-1;
                    });
                    return locations.concat(questions);
                }
                function onPageChange(val){
                    if(val === $scope.PAGE_MAP){
                        if($scope.hoursRemaining === 0) 
                        {
                            $scope.setCurrentPage($scope.PAGE_LOSE_PRE);
                                var evt = {
                                    eventCategory: "GRTT: Game",
                                    eventLabel:  "GRTT: game"
                                };
                                gtag("event", "GRTT: end - incomplete", evt);
                        }
                        $scope.localLocation = null;
                    }
                }
            },
            link: function($scope, element, attributes){
                $scope.popup = {
                    position: {
                        top: 0,
                        left: 0
                    }
                };
            }
        };

    }]);
